import { use } from 'react';

import { TRPC, TRPCContext } from '../contexts/TRPC';

export function useTRPC(): TRPC['client'] {
  const context = use(TRPCContext);
  return context.client;
}
